
/**
 * url参数解析
 * @example String "https://mp.csdn.net?id=123456&a=b"
 * @return Object {id:"123456",a:"b"}
 */
import { DetailType } from "../types/FmsEnums";
import { IPgProps, ISearchPage } from "../types/FmsTypes";
import { ValidateErrorEntity } from "rc-field-form/es/interface"

import { PaginationProps } from "antd/es/pagination";
import { TablePaginationConfig } from "antd/es/table/interface";

type UrlType = {
    [key: string]: any
}
export interface Optios {
    key: string,
    label: string,
    value: string,
    [key: string]: any
}
interface RepeatedObj {
    [key: string]: boolean
}
export function urlParse(url: string): UrlType {

    let obj: UrlType = {}
    /*
    * 正则匹配
    * [?&]:匹配?或&其一
    * [^?&]:非?或非&
    * */
    let reg = /[?&][^?&]+=[^?&]+/g
    let arr = url.match(reg)
    if (arr) {
        arr.forEach((item) => {
            let tempArr = item.substring(1).split('=')
            // console.log(tempArr)
            let key = tempArr[0]
            let val = tempArr[1]
            obj[key] = val
        })
    }
    return obj
};


/**
 *根据要查找的key返回这一项 （递归查找）
 * @param {Array}  array 要查找的源数组
 * @param {string} code   唯一标识
 * @param {string} key   要查找的键名， 和code对应的  默认id
 * @param {Boolean} filter   查找是否过滤掉不要在左侧菜单展示的页面
 */

export function forFind(array: any[], code: string, key: string = "id", filter: boolean = false) {
    for (const item of array) {
        if (item[key] === code && (filter ? item.isShow : true)) {
            return item
        }
        if (item.children && item.children.length > 0) {
            let forFindRet: any = forFind(item.children, code, key, filter);
            if (forFindRet) {
                return forFindRet
            }
        }
    }
}
export function forDictFind(code: string, array?: any[]) {
    for (const item of array as any[]) {
        if (item.code === code) {
            return item;
        }
        if (item.children && item.children.length > 0) {
            let forFindRet:any = forDictFind(code,item.children);
            if (forFindRet) {
                return forFindRet;
            }
        }
    }
}
export const loadDictParam = (dictItem: string, dict: any[], nameOrVal: string = "code") => {
    let findItem = forDictFind(dictItem, dict)
    let optionArr = findItem ? filterArrId(findItem.children, nameOrVal) : []
    return optionArr
}
//变成options格式
export function filterArrId<T>(arr: T[], nameOrVal: string = "code", label?: string): Optios[] {
    let obj: RepeatedObj = {};
    let newArr: Optios[] = [];
    arr.forEach((item: any) => {
        if (!obj[item.code]) {
            newArr.push({
                key: item.key,
                label: item[label as string] ?? item.tableName ?? item.name ?? item.code,
                value: item[nameOrVal],
                nameen:item.nameEn,
                namech:item?.name
                // ...item
            });
            obj[item.code] = true;
        }
    });
    return newArr;
}
//筛选option选中时对应的数组 
export const findOption = (value: string, options: Optios[]) => {
    return options.find((item: Optios) => value == item.value)
}
export const setTitle = (tit: string) => {
    switch (tit) {
        case DetailType.add: return "新增";
        case DetailType.edit: return "编辑";
        case DetailType.look: return "查看";
        default: return false;
    }
}
export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}

//re-from 错误校验提示信息方法
export function getFormValidatorErrText(error: ValidateErrorEntity) {
    let { errorFields } = error;
    for (let key in errorFields) {
        if (errorFields[key]?.errors?.length > 0) {
            return errorFields[key]?.errors[0];
        }
    }
    return '未知问题!';
}
//关闭浏览器页签
export function closeWebPage() {
    if (navigator.userAgent.indexOf("MSIE") > 0) { // IE
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {// IE6
            window.opener = null;
            window.close();
        } else {// IE6+
            window.open('', '_top');
            window.top?.close();
        }
    } else if (navigator.userAgent.indexOf("Firefox") > 0 || navigator.userAgent.indexOf("Presto") > 0) {// FF和Opera
        window.location.href = 'about:blank';
        window.close();// 火狐默认状态非window.open的页面window.close是无效的
    } else {
        window.opener = null;
        window.open('', '_self', '');
        window.close();
    }
}